import ITokenResponse from 'js-pkce/dist/ITokenResponse';
import { initiatePKCE } from '@/utils/auth';

export const exchangeAccessToken = async (): Promise<ITokenResponse> => {
  const pkce = initiatePKCE();

  const response = await pkce.exchangeForAccessToken(
    window.location.toString()
  );

  return response;
};
